export default __webpack_public_path__ + "static/media/ic_melilla.9ee37821.svg";